export default __webpack_public_path__ + "static/media/marker-red.a8fb16c8.png";